import { render, staticRenderFns } from "./Banner7.vue?vue&type=template&id=0b9c7963"
import script from "./Banner7.vue?vue&type=script&lang=js"
export * from "./Banner7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports